export default function stageAnimations(element, data) {
    const stageBlocks = element.querySelectorAll('.stage__block_item');
    const counterItems = element.querySelectorAll('.circles-counter-item');

    stageBlocks.forEach(stageBlock => {
        stageBlock.addEventListener('mouseenter', function () {
            const id = stageBlock.dataset.id;

            counterItems.forEach(counterItem => {
                counterItem.classList.toggle(
                    'active',
                    counterItem.dataset.id === id
                );
            });
        });

        stageBlock.addEventListener('mouseleave', function () {
            counterItems.forEach(counterItem => {
                counterItem.classList.remove('active');
            });
        });
    });
};